import { ColorModeScript as ChakraColorModeScript } from '@chakra-ui/react'

import { uiTheme } from '../_theme'

export default function ColorModeScript() {
  return (
    <ChakraColorModeScript initialColorMode={uiTheme.config.initialColorMode} />
  )
}
